import { createContext, useContext } from 'react'
import type { KnownCuidEntity, KnownCuidMap } from './cuidExpand'

const ChatEntityNamesContext = createContext<KnownCuidMap>({})

/** Survives navigation so CUID links keep showing entity names in prior chat turns. */
const rememberedEntities = new Map<string, KnownCuidEntity>()

export function rememberChatEntities(entities: KnownCuidMap): void {
  for (const [id, entity] of Object.entries(entities)) {
    if (entity?.name?.trim()) {
      rememberedEntities.set(id, entity)
    }
  }
}

export function getRememberedChatEntities(): KnownCuidMap {
  return Object.fromEntries(rememberedEntities.entries())
}

export const ChatEntityNamesProvider = ChatEntityNamesContext.Provider

export function useChatEntityNames(): KnownCuidMap {
  return useContext(ChatEntityNamesContext)
}
